import { Box, Tab, Tabs, Typography } from "@mui/material"
import { a11yProps, TabPanel } from "../../../components/tab"
import { ContasViewProps, mapDispatchToContasProps, mapStateToContasProps } from "../contas.controll"
import { useState } from "react"
import ContasResumo from "./contas.resumo.list"
import { connect } from "react-redux"


function ContasTab(props: ContasViewProps){
    const { tabValue } = props.contasState
    const { setTabValue,readResumoContas } = props.contasActions
    const [tipo,setTipo] = useState<"receber"|"pagar">("receber")

    const handleChangeTab = (event: React.SyntheticEvent, value: any) => {
        setTabValue(value);
        value === 0 ? setTipo("receber"):setTipo("pagar");
    }

    return (
        <Box sx={{ display: "flex", flex: 1, flexDirection: "column", pt: 1, width: "100%" }}>
            <Box sx={{ display: "flex", flex: 1, borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabValue} onChange={handleChangeTab} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile aria-label="Contas">
                    <Tab  label={<Typography variant="subtitle1">Contas a Receber</Typography>} {...a11yProps(0)} />
                    <Tab  label={<Typography variant="subtitle1">Contas a Pagar</Typography>} {...a11yProps(1)} />
                </Tabs>
            </Box>
            <TabPanel  value={tabValue} index={0}  >
                <ContasResumo  tipo={tipo} />
            </TabPanel>
            <TabPanel  value={tabValue} index={1}  >
                <ContasResumo  tipo={tipo} />
            </TabPanel>


        </Box>
    )
}

export default connect(mapStateToContasProps, mapDispatchToContasProps)(ContasTab);